export * from './NewsTemplate'
